import styled from "styled-components";
import {device} from '../app/devices';

export const AppointmentInfoContainer = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: var(--spacer-S);
    @media ${device.mobileL} {
        flex-direction: row;
    }
`;

export const AppointmentPhotoContainer = styled.div`
    display: flex;
    flex-grow: 0;
`;

export const AppointmentInfoLeftContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const DateTimeContainer = styled.div`
    display: flex;
    flex-direction: column;
    text-align: end;
    flex-grow: 1;
`;